import { typographyTokens } from '../../../theme/typographyTokens';
import React, { useState } from 'react';
import { Box, Divider, Typography,Stack } from '@mui/material';
import AdminHeader from '../../../components/Admin/AdminHeader';
import QuickHelpMenu from '../../../components/Admin/SEPApplication/QuickHelpMenu';
import ProgressBarSection from '../../../components/Admin/SEPApplication/ProgressBarSection';
import SEPBanner  from '../../../components/Admin/SEPApplication/SEPBanner';
import ModalWidget from '../../../components/ModalWidget/ModalWidget';
import UpsertSEPSetting from '../../../components/Admin/SEPApplication/UpsertSEPSetting';
import { useGetSettingsQuery,useDeleteSettingMutation } from '../../../services/appSlice/appSlice';
import ReviewerTools from '../../../components/Admin/SEPApplication/ReviewerTools';
import { Setting } from '../../../../shared/types/Settings';
import HoveredIconConfirm from '../../../components/Admin/HoveredIconConfirmButton';
import HoveredIcon from '../../../components/Admin/HoveredIconButton';
import AddButton from '../../../components/Admin/AddButton';

const SEPApplication = () => {
  const { data } = useGetSettingsQuery();
  const [deleteSetting] = useDeleteSettingMutation();
  const [applicationSettingType, setApplicationSettingType] = useState('Quick Help Menu')
  const sepSettings = data
  ?.filter((help) => help.section === 'SepSettings')
  const reviewerTools = data
    ?.filter((help) => help.section === 'ReviewerTools')
    .sort((a, b) => a.order - b.order);
  const userHelp = data
    ?.filter((help) => help.section === 'UserHelp')
    .sort((a, b) => a.order - b.order);
  const progressBarHelp = data
    ?.filter((help) => help.section === 'ProgressBar')
    .sort((a, b) => a.order - b.order);

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState<Setting | undefined>(undefined);

   const handleEdit = (item: any) => {
      setEdit(item as Setting);
      setTimeout(() => setOpen(true), 0);
    };
    const handleDelete = (item: any) => {
      deleteSetting(item.id);
    };
  
  return (
    <>
      <ModalWidget
        isOpen={open}
        title={edit ? 'Edit SEP Setting' : 'Add SEP Setting'}
        children={
          <UpsertSEPSetting
            section="SepSettings"
            item={edit}
            onClose={() => setOpen(false)}
          />
        }
        onClose={() => {
          setOpen(false);
          setEdit(undefined);
        }}
      />
      <Box sx={{ minHeight: '500px' }}>
        <AdminHeader title="SEP Application" setApplicationSettingType={setApplicationSettingType} />
        {applicationSettingType === 'SEP Banner' ? (
          <SEPBanner />
        ) : applicationSettingType === 'Quick Help Menu' ? <>
        <Box sx={{ padding: '0px 40px 15px 40px' }}>
        <Typography
          variant="h2"
          component="div"
          sx={{
            marginTop: '16px',
            fontSize: typographyTokens.fontSizes.xs,
            color: '#7E8083',
          }}
        >
          <i className="fa-solid fa-circle-info"></i>
          &nbsp;&nbsp;Drag to rearrange order in Quick Help Menu
        </Typography>
        {userHelp && <QuickHelpMenu items={userHelp} />}
      </Box>

       <Divider />
      <Box sx={{ padding: '0px 40px 15px 40px' }}>
        <Typography
          variant="h2"
          component="div"
          sx={{
            marginTop: '16px',
            fontSize: typographyTokens.fontSizes.xs,
            color: '#7E8083',
          }}
        >
          <i className="fa-solid fa-circle-info"></i>
          &nbsp;&nbsp;SEP Progress Bar
        </Typography>
        {progressBarHelp && <ProgressBarSection items={progressBarHelp} />}
      </Box>

      <Divider />
      <Box sx={{ padding: '0px 40px 15px 40px' }}>
        <Typography
          variant="h2"
          component="div"
          sx={{
            marginTop: '16px',
            fontSize: typographyTokens.fontSizes.xs,
            color: '#7E8083',
          }}
        >
          <i className="fa-solid fa-circle-info"></i>
          &nbsp;&nbsp;The section below is only visible to Stakeholder Users
        </Typography>
        {reviewerTools && <ReviewerTools items={reviewerTools} />}
      </Box>
      </>
      :
      <>
      <Box sx={{margin:'35px'}}>
      {sepSettings?.map((item, index) => {
                      return (
                        
                       
                        <Stack
                        direction="row"
                        spacing={2}
                        p={2}
                        sx={{
                        alignItems: 'center',
                        border: '1px solid #222',
                        borderRadius: '4px',
                        margin: '16px 0px',
                        }}
                      >
                        <Stack direction="column">
                          <Typography
                            sx={{
                              textAlign: 'left',
                              font: 'normal normal normal 16px/22px Open Sans',
                              letterSpacing: '0px',
                              // color: '#222222',
                              opacity: 1,
                            }}
                          >
                            {item.name}
                          </Typography>
                        </Stack>
                        <Stack direction="column">
                          <Typography
                            sx={{
                              textAlign: 'left',
                              font: 'normal normal normal 16px/22px Open Sans',
                              letterSpacing: '0px',
                              // color: '#222222',
                              opacity: 1,
                            }}
                          >
                            {item.value}
                          </Typography>
                        </Stack>
                        <Box sx={{ marginLeft: 'auto !important' }}>
                          <HoveredIconConfirm
                            icon="fa-regular fa-trash"
                            hoverIcon="fa-solid fa-trash"
                            title="Delete Menu Item"
                            content={`Are you sure you want to delete [${
                              item.name
                            }]?`}
                            onClick={() => handleDelete(item)}
                          />
                        </Box>
                        <Box>
                          <HoveredIcon
                            icon="fa-regular fa-pencil"
                            hoverIcon="fa-solid fa-pencil"
                            onClick={() => handleEdit(item)}
                          />
                        </Box>
                      </Stack>
                      );
                    })}
                    <AddButton
        tab="Menu Item"
        onAdd={(tab: string) => {
          setOpen(true);
        }}
      />
      </Box>
      </>}     
    </Box>
    </>
  );
};

export default SEPApplication;
